import { makeOperator } from './Operator';
import isString from 'transmute/isString';
export default makeOperator({
  name: 'NeverContained',
  values: [{
    name: 'value',
    isValid: isString
  }]
});